import { Textarea } from "@mantine/core";
import { useFormProvider } from "../../../../providers";

export function ComplaintComponent() {
  const { complaint } = useFormProvider();

  return <Textarea minRows={5} label="Keluhan" value={complaint} disabled />;
}
